import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}savings-accounts`;

export default {
  list(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
  create(payload) {
    return axios.post(API_URL, payload, { headers: buildHeaders() });
  },
  show(id) {
    return axios.get(`${API_URL}/${id}`, { headers: buildHeaders() });
  },
  update(id, payload) {
    return axios.put(`${API_URL}/${id}`, payload, { headers: buildHeaders() });
  },
  destroy(id) {
    return axios.delete(`${API_URL}/${id}`, { headers: buildHeaders() });
  },
};
